
const alertaStyles = {
    alertBox: {
        padding: '1rem',
        border: '1px solid #B2B2B2;',
        display: 'flex',
        borderRadius: '8px',
        gap: '8px',
        marginBottom: '1rem',
        background: 'rgba(233, 233, 233, 0.30)',
    },
    alertTitle: {
        color: '#323232',
        fontSize: '16px',
        lineHeight: '25px',
        fontWeight: '600',
        letterSpacing: '0.15px',
    },
    alertSubtitle: {
        color: '#323232',
        lineHeight: '22px',
        fontSize: '14px',
        fontWeight: '400',
        letterSpacing: '0.17px',
    }
};

export default alertaStyles;